import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import _ from 'lodash'

const TecFooterMain = () => {
 
  useEffect(()=>{  

    getTecFooter()
  }, [])

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
     ///getTecFooter


     const [sectionFooter, setSectionFooter] = useState([])
     const [EditSectionFooter, setEditSectionFooter] =useState([])


  function getTecFooter()
  {

  var token=JSON.parse(localStorage.getItem('usertoken'));
  console.log("Token", token)

  fetch(`${BASE_URL}/Tec/GettecFooter`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("DatasectionA", data);
      setSectionFooter(data)

        }
    );



      }


      ///submitsection

  
 
   function submitsectionFooter(){



     var textFooter = document.getElementById("textFooter").value;
     var DescriptionFooter=document.getElementById("DescriptionFooter").value;
     console.log(textFooter)

    
     if(!textFooter){

       document.getElementById("AddErrA").innerHTML="Heading Required"
       
       
     }
     else if(textFooter){

       document.getElementById("AddErrA").innerHTML=" "
      
     }

     if(!DescriptionFooter){

      document.getElementById("AddErrB").innerHTML="Description Required"
     }

     else if(DescriptionFooter){

      document.getElementById("AddErrB").innerHTML="  "

     }
     
   

     if(textFooter  && DescriptionFooter){



    const body =
     {
       
       Text:textFooter, 
      
       Description: DescriptionFooter,
       ActiveStatus:0,
       DeleteStatus:0

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/AddtecFooter`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
          
             toast.success("Section Added")
           
          
             setTimeout(() => {
             
              getTecFooter()

              closeFooterAddForm()
             }, 1000);
           }

   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     toast.warning("failed to Add") 

     })
       
   }

   }


   
     ////Get Particular Data PostMethod

     function editSectionFooter(Id){


      document.getElementById("FooterEditPop").style.display = "block";
 
    const body =
     {
       
      id:Id
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/EdittecFooter`,
            data:body, 
            headers: {
                 "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
         
    
         .then((response) =>{
           console.log(JSON.stringify(response.data));
      
       
           setEditSectionFooter(response.data)

          
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }



     function updateSectionFooter(Id){


    
       var TextFooter = document.getElementById("textFooterA").value;
       var DescriptionFooter = document.getElementById("DescriptionFooterA").value;



       
       if(!TextFooter){

         document.getElementById("ErrA").innerHTML="Heading Required"

       }
       else if(TextFooter){

         document.getElementById("ErrA").innerHTML=" "

       }
       
      
       if(!DescriptionFooter){

        document.getElementById("ErrB").innerHTML="Description Required"

      }
      else if(DescriptionFooter){

        document.getElementById("ErrB").innerHTML=" "

      }
      
       if(TextFooter && DescriptionFooter){


       



    const body =
     {
       Id:Id,
       Text:TextFooter, 
       
       Description:DescriptionFooter,
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/UpdatetecFooter`,
            data:body, 
            headers: {
                 "Content-Type": "multipart/form-data",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        if(response.data.status === "Success"){
        
             toast.success("Section Updated")
           
             setTimeout(() => {
             
              getTecFooter()

              closeFooterEditForm()
             }, 1000);
           }
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     toast.warning("failed to Update")   
     })
       
    
   }

     }
   

   ///DeleteSectionA

   function DeleteSectionFooter(Id){

 
     var ans = window.confirm("Are You sure  want to Delete this User?");
 
     if(ans==true){

    const body =
     {
       Id:Id,
    
      

        
     
     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Tec/DeletetecFooter`,
            data:body, 
            headers: {
               "Content-type": "application/json",
                 'Authorization':bearer 
             }     
         }) 
 
        .then((response) =>{
        console.log(response.data);
   
   
        
        
             toast.info("Section Deleted")
           
             setTimeout(() => {
             
              getTecFooter()

              
             }, 1000);
            
             
           
   
     })
     .catch(error => {
       console.log(error);
     //  alert("failed !")
     toast.warning("failed to Update")   
     })
       
    

   }

   }




  //OpenAddForm
  function openFooterForm(){

    document.getElementById("FooterAddPop").style.display = "block";

  }

  //closeAddForm
  function closeFooterAddForm(){



   
 
    document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("AddErrB").innerHTML=" "

    document.getElementById("tecformFooter").reset();
           
   
     document.getElementById("FooterAddPop").style.display = "none";
   
  }
  //closeEditForm
  function closeFooterEditForm(){


    document.getElementById("ErrA").innerHTML=" "
    document.getElementById("ErrB").innerHTML=" "
    document.getElementById("teceditform").reset();
 
    document.getElementById("FooterEditPop").style.display = "none";
   }
   
      
   

    
  return (
    <div className='tec-addmain'>
      
    <ToastContainer id="toast"
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        /> 
        
  <div className="tec-addgrid-layout">
<div className="tec-addmain-top">
  <div className='tec-addmain-back'>
  <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
  </div> 
  <span>Footer</span>
  
  </div>
  </div>

  <div className='tec-addmain-add'>
   <button className='add-user' onClick={openFooterForm}>Add Footer</button>
   </div>  

  <div>
    
    <div className='tec-sectionMain'>

     {/* EditFirst */}
 <div className='tec-pop-fade' id="FooterEditPop">
{EditSectionFooter.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeFooterEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="teceditform" onSubmit={()=>updateSectionFooter(e.id)}>
      <div className="modal-body mx-3">
     
        <div className="md-form mb-5">
        <label id="sectionlable">Heading</label> 
          <input type="text" id="textFooterA"  defaultValue={e.text}/>
          <span id="ErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Content</label> 
          <input type="url" id="DescriptionFooterA"  defaultValue={e.description}/>
          <span id="ErrB" className='error'></span>
        </div> 
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>

{/* AddFirst */}
<div className='tec-pop-fade' id="FooterAddPop">

  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
        <button type="button" className="close" onClick={closeFooterAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecformFooter" onSubmit={submitsectionFooter} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
       
        <label id="sectionlable">Heading</label> 
          <input type="text" id="textFooter"/>
          <span id="AddErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">
           
        <label id="sectionlable"> Content</label> 
          <input type="url" id="DescriptionFooter"/>
          <span id="AddErrB" className='error'></span>
        </div> 
        

        

       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
  </div>

</div> 

{/* Table  */}
<div>
<div className='tectable'>

  <div class="tec-table_responsive">
<table>
  <thead>
    <tr>

      <th>Heading</th>
      <th>Content</th>
      
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {sectionFooter.map((e)=>{
    
  
    return<tr>
    <td>{e.text}</td>
    <td>{e.description}</td>
   

   
    <td>
      <span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionFooter(e.id)} id="tecEditicon"></i></span> &nbsp;&nbsp;
      <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>DeleteSectionFooter(e.id)} id="tecDelicon"></i></span>
    </td>
    </tr>
 } )}
  </tbody>
</table>
</div>
</div>
</div>


    </div>
    </div>

    </div>
  )
}

export default TecFooterMain
